import {getIsProfilesLoaded, getProfiles} from './../redux/reducers/index';
import {Injectable} from '@angular/core';
import {ProfileService} from "../services/profile.service";
import {Store} from "@ngrx/store";
import {StoreState} from "../redux/reducers";
import {combineLatest, Observable} from "rxjs";
import {Profile} from "@model/profile";
import {filter, map} from "rxjs/operators";
import {profileAction} from "../redux/actions/profiles.action";
import {Router} from "@angular/router";
import {StorageService} from '../services/storage.service';
import {AuthenticationService} from '@services/authentication.service';

export const LOCAL_STORAGE_SELECTED_PROFILE_KEY = 'cabanga_selected_profile_id';

@Injectable({
  providedIn: 'root'
})
export class ProfilesFacadeService {

  profiles$: Observable<Profile[]>;

  selectedProfile$: Observable<Profile>;

  constructor(private _profileService: ProfileService,
              private _authenticationService: AuthenticationService,
              private _localStorage: StorageService,
              private _store: Store<StoreState>,
              private _router: Router) {
    this.profiles$ = combineLatest(
      this._store.select(getProfiles),
      this._store.select(getIsProfilesLoaded)
    ).pipe(
      filter(([profiles, isLoaded]) => isLoaded),
      map(([profiles]) => profiles)
    );
  }

  selectProfile(profile: Profile) {
    this._localStorage.setItem(LOCAL_STORAGE_SELECTED_PROFILE_KEY, profile.id.toString());
    this._store.dispatch(profileAction.setProfileSelected({profile}));
    this._router.navigate(['app']);
  }

  logout() {
    this._authenticationService.logout();
  }
}
